import { FC } from 'react';
import { RootState } from '../../redux/AppReducer';
import { useSelector } from 'react-redux';

export enum GenericSVGComponentKey {
	LABEL,
	CARDS,
	MAP_DISCOVER,
	MAP
}
interface IGenericSVGPrepComponentProps {
	componentKey: GenericSVGComponentKey;
}

const GenericSVGPrepComponent: FC<IGenericSVGPrepComponentProps> = ({ componentKey }) => {
	const currentEvent = useSelector(
		(state: RootState) => state.appState.storeState?.getCurrentEvent
	);
	const events: {
		[key: string]: (React.FunctionComponent<React.SVGProps<SVGSVGElement>> | null)[];
	} = {
		expoeast: [
			//ExpoEastLabel, ExpoEastCard, EastMapDiscover, ExpoEastMap
		],
		expowest: [
			//ExpoWestLabel, ExporWestCard, WestMapDiscover, ExpoWestMap
		]
	};
	const event = currentEvent
		? events[currentEvent.name.replace(/\s+/g, '').toLocaleLowerCase().trim()]
			? events[currentEvent.name.replace(/\s+/g, '').toLocaleLowerCase().trim()]
			: null
		: (null as any);
	const Component = event ? event[componentKey] : null;
	return <>{Component && <Component />}</>;
};

export default GenericSVGPrepComponent;
